import React from 'react'
import { ReactComponent as PlayIcon } from 'assets/icons/play.svg'
import { ReactComponent as PauseIcon } from 'assets/icons/pause.svg'
import { useSessionAudioPlayer } from './hooks/useSessionAudioPlayer'
import s from '../NoteTakerDrawer.module.scss'

const SessionAudioPlayer = ({ sessionNoteId, durationMs = 0, enabled = true }) => {
	const player = useSessionAudioPlayer({
		sessionNoteId,
		enabled,
		fallbackDurationMs: durationMs,
	})

	const progress = player.durationMs
		? Math.min(100, (player.currentTimeMs / player.durationMs) * 100)
		: 0

	const canScrub = player.durationMs > 0 && !player.isLoading && !player.error
	const sliderValue = canScrub
		? Math.min(player.currentTimeMs, player.durationMs)
		: 0

	return (
		<div className={s.audioPlayerChip}>
			<button
				type="button"
				className={s.audioChipPlay}
				onClick={() => player.togglePlay()}
				disabled={player.isLoading || Boolean(player.error)}
				aria-label={player.isPlaying ? 'Pause recording' : 'Play recording'}
			>
				{player.isLoading ? (
					<span className={s.audioChipLoading} aria-hidden />
				) : player.isPlaying ? (
					<PauseIcon />
				) : (
					<PlayIcon />
				)}
			</button>

			<div className={s.audioChipBody}>
				{player.error ? (
					<div className={s.audioChipError}>
						<span>{player.error.message}</span>
						<button type="button" onClick={() => player.retry()}>
							Retry
						</button>
					</div>
				) : (
					<>
						<div
							className={s.audioChipProgress}
							style={{ '--progress': `${progress}%` }}
						>
							<input
								type="range"
								min={0}
								max={player.durationMs || 1}
								step={100}
								value={sliderValue}
								disabled={!canScrub}
								onChange={event => player.seek(Number(event.target.value))}
								onInput={event => player.seek(Number(event.target.value))}
								aria-label="Recording position"
								aria-valuemin={0}
								aria-valuemax={player.durationMs}
								aria-valuenow={player.currentTimeMs}
							/>
						</div>
						<div className={s.audioChipTimes}>
							<span>{player.formatTimeMs(player.currentTimeMs)}</span>
							<span>{player.formatTimeMs(player.durationMs)}</span>
						</div>
					</>
				)}
			</div>
		</div>
	)
}

export default SessionAudioPlayer
